import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ChatTest from "./components/live-api/chat-test";
import { BrowserRouter } from "react-router-dom";
import AppRouting from "./app-routing";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        {/*<App />*/}
        {/*  <ChatTest/>*/}
        <AppRouting />
      </BrowserRouter>
    </MsalProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
